module.exports = __webpack_public_path__ + "static/media/menu-landing-pages-instagram.4e175017.svg";